module.exports = __webpack_public_path__ + "static/media/cancle-subscription-mobile.b0340228.svg";